import api from '../config/Api';

const endpoint = 'v1/session';
const endpoint2 = 'v2/session';

export default {

  getGeneralData( id, params ) {
    return api.get( `${endpoint}/${id}/dashboard/student/general-data`, params );
  },

  getRankingRounds( id, params ) {
    return api.get( `${endpoint}/${id}/dashboard/student/ranking-round`, params );
  },

  getRankingChart( id, params ) {
    return api.get( `${endpoint}/${id}/dashboard/student/ranking-graph`, params );
  },

  getMyProducts( id, params ) {
    return api.get( `${endpoint}/${id}/dashboard/student/my-products`, params );
  },

  getMyServices( id, params ) {
    return api.get( `${endpoint}/${id}/dashboard/student/my-services`, params );
  },

  getMyBundles( id, params ) {
    return api.get( `${endpoint}/${id}/dashboard/student/my-bundles`, params );
  },

  getHistoricalChart( id, workgroupId, params ) {
    return api.get( `${endpoint2}/${id}/workgroup/${workgroupId}/profit-loss`, params );
  },

  getHistoricalMarket( id, workgroupId, categoryId, params ) {
    return api.get( `${endpoint2}/${id}/market/products/?workgroup=${workgroupId}&category=${categoryId}`, params );
  },

  getServicesLastRound( id, params ) {
    return api.get( `${endpoint2}/${id}/market/services-last-round`, params );
  },

  getBundlesLastRound( id, params ) {
    return api.get( `${endpoint2}/${id}/market/bundles-last-round`, params );
  },

  getHistoricalProducts( id, workgroupId, params ) {
    return api.get( `${endpoint2}/${id}/product/information?workgroup=${workgroupId}`, params );
  },

  getHistoricalBundle( id, params ) {
    return api.get( `${endpoint2}/${id}/bundle/information`, params );
  },

  getBundlesAllRounds( id, params ) {
    return api.get( `${endpoint2}/${id}/market/bundles-all-round`, params );
  },

  getServicesAllRounds( id ) {
    return api.get( `${endpoint2}/${id}/market/services-all-round` );
  },

  getCustomerInformation( id, params ) {
    return api.get( `${endpoint2}/${id}/customer/information`, params );
  },

  getCustomerEvolution( id, params ) {
    return api.get( `${endpoint2}/${id}/customer/evolution`, params );
  },
  getCustomerRetention( id, params ) {
    return api.get( `${endpoint2}/${id}/customer/retention/rate`, params );
  },
  getCustomerAvgRevenue( id, params ) {
    return api.get( `${endpoint2}/${id}/customer/average/revenue`, params );
  },
  getPLComparison( id, params ) {
    return api.get( `${endpoint2}/${id}/profit-loss/all-workgroup`, params );
  },
  getStockValueAllWorkgroup( id, params ) {
    return api.get( `${endpoint2}/${id}/stock-value/all-workgroup`, params );
  },

  getTotalCustomer( id, params ) {
    return api.get( `${endpoint2}/${id}/customer/total/number`, params );
  },

};
